import * as React from 'react'
import { Accordion as BSAccordion } from 'react-bootstrap'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { styled } from 'styled-components'
import { faQuestion } from '@fortawesome/pro-solid-svg-icons'
import { AccordionToggleButton } from '~/components/Buttons'

export interface NameItem {
  id: number
  name: string
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  padding: 0.5rem 0.5rem 0.5rem 1.5rem;

  background: var(--primary);
  color: var(--bs-white);
  border-radius: 2rem;

  font-size: 1.5rem;

  .wrapper {
    & > * {
      gap: 1rem;
    }
  }

  .clear-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    height: max-content;
    border-radius: 50%;
    padding: 0.5rem;
    margin: 0;
    width: 2.5rem;
    background: var(--bs-white);
    color: var(--primary);

    svg {
      fill: var(--primary);
    }
  }

  .btn {
    box-shadow: none !important;
    background: var(--bs-white) !important;
    color: var(--primary) !important;

    margin: 0 !important;
    padding: 0 !important;
    font-size: 1.25rem;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 2.5rem;
    height: 100%;
  }
`

const Autocomplete = styled(ReactSearchAutocomplete<NameItem>)`
  flex: 1 0 auto;
  input:focus {
    background-color: var(--primary-light);
  }
`
const Accordion = styled(BSAccordion)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Collapse = styled(Accordion.Collapse)`
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
`

interface Props {
  title: string
  description: string
  names: ReadonlyArray<NameItem>
  index: number
  onSelectName: (item: NameItem) => void
  onClearName: () => void
}

export const View: React.FC<Props> = ({ title, description, names, index, onSelectName, onClearName }) => {
  return (
    <Accordion>
      <Container>
        <Autocomplete
          items={names as any}
          placeholder={title}
          onSelect={onSelectName}
          onClear={onClearName}
          styling={{
            border: 'none',
            iconColor: 'white',
            searchIconMargin: '0',
            color: 'white',
            backgroundColor: 'var(--primary)',
            boxShadow: 'none',
            fontFamily: '"Source Sans 3"',
            fontSize: '1.5rem',
            height: '36px',
            placeholderColor: 'rgba(255,255,255,0.75)',
            hoverBackgroundColor: 'var(--primary)',
            zIndex: 100 - index
          }}
        />
        <AccordionToggleButton eventKey={`autocomplete-${index}`} iconActive={faQuestion} iconInactive={faQuestion} />
      </Container>
      <Collapse key={index} eventKey={`autocomplete-${index}`}>
        <p>{description}</p>
      </Collapse>
    </Accordion>
  )
}

export default Object.assign(View, {})
